module.exports = __webpack_public_path__ + "images/view-deal-directory.png";